var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "3" } }, [_c("Menu")], 1),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "b-row",
                { staticClass: "border" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "head", attrs: { cols: "12" } },
                            [
                              _c("h4", [_vm._v(":: Contacto")]),
                              _vm._v(" "),
                              _c(
                                "b-btn",
                                {
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.descargar_csv.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Descargar Lista")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "breadcrumb",
                              attrs: { cols: "12" }
                            },
                            [
                              _vm._v(
                                "\n                  » Lista de mensajes de contactos para " +
                                  _vm._s(this.brand) +
                                  ":\n                "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-2" }),
                      _vm._v(" "),
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          items: _vm.contacts,
                          fields: _vm.fields
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "actions",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: { size: "sm" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.details(row.item)
                                      }
                                    }
                                  },
                                  [_vm._v("Ver detalle")]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _vm.errors && _vm.errors.length
                        ? _c(
                            "ul",
                            _vm._l(_vm.errors, function(error, index) {
                              return _c(
                                "li",
                                { key: index },
                                [
                                  _c("b-alert", { attrs: { show: "" } }, [
                                    _vm._v(_vm._s(error.message))
                                  ])
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02c4503a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02c4503a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supervisor/Contacts.vue
// module id = null
// module chunks = 